import axios from "axios";
import { Message } from "element-ui";
// 创建一个axios的实例
const Axios = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 5000,
  headers: {
    "Content-Type": "application/json;charset=UTF-8",
  },
});

// 添加请求拦截
Axios.interceptors.request.use(
  (config) => {
    if (config.url == "/nodeservice/addLog") {
      config.url = "https://www.caoss.vip" + config.url;
    } else {
      config.url = process.env.VUE_APP_BASE_API + config.url;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// 添加响应拦截器

Axios.interceptors.response.use(
  (res) => {
    let { data } = res;
    if (typeof data == "string") {
      data = JSON.parse(data);
    }
    if (data.code == 400) {
      Message({
        message: data.msg || data.message || data.reason,
        type: "error",
        duration: 2 * 1000,
      });
      return;
    }
    if (
      data.code == 200 ||
      (res.status == 200 && data.status != 500 && data.code != 500)
    ) {
      return res.data;
    } else if (data.code == 500) {
      Message({
        message: data.msg || data.message,
        type: "error",
        duration: 2 * 1000,
      });
      return Promise.reject(data);
    } else {
      Message({
        message: data.msg || data.message || data.reason,
        type: "error",
        duration: 2 * 1000,
      });
      return Promise.reject(data);
    }
  },

  (err) => {
    const status = err?.response?.status;
    const message = status
      ? `请求错误(${status})`
      : err.toString();
    Message({
      message,
      type: "error",
      duration: 2 * 1000,
    });
    return Promise.reject(message);
  }
);

export default Axios;
